export default __webpack_public_path__ + "static/media/2053-loading-black.7568a170.gif";